import { createAction, props } from '@ngrx/store';
import { StatusApiMsgModel } from '@kanzi-apes/kanzi-models';

export const statusOnline = createAction(
  '[Monitoring] Status Online',
  props<{ payload: StatusApiMsgModel }>()
);

export const statusOffline = createAction(
  '[Monitoring] Status Offline',
  props<{ payload: StatusApiMsgModel }>()
);
